var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketingProjectContent" },
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "40px",
            display: "flex",
            "flex-direction": "row-reverse",
            "justify-content": "space-around",
            "align-items": "center"
          }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "150px" },
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.createdProject }
            },
            [_vm._v("基本信息设置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v("返回")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "border-radius": "25px" },
          attrs: {
            "destroy-on-close": "",
            title: "创建项目",
            visible: _vm.dialogVisible,
            width: "500px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名称", prop: "projectName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "290px" },
                    model: {
                      value: _vm.ruleForm.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "projectName", $$v)
                      },
                      expression: "ruleForm.projectName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目简介", prop: "content" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "290px" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.ruleForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "content", $$v)
                      },
                      expression: "ruleForm.content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目引入", prop: "subjectId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "290px" },
                      attrs: { placeholder: "请选择资源" },
                      model: {
                        value: _vm.ruleForm.subjectId,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "subjectId", $$v)
                        },
                        expression: "ruleForm.subjectId"
                      }
                    },
                    _vm._l(_vm.subjectList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "upload_custom",
                  attrs: { label: "上传图片", prop: "cover" }
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "addUpload",
                      attrs: {
                        "file-list": _vm.flieList,
                        "list-type": "picture-card",
                        action: _vm.materialForm.url,
                        headers: _vm.headers,
                        "on-success": _vm.handleAvatarSuccess
                      }
                    },
                    [_c("i", { staticClass: "el-input__icon el-icon-plus" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center !important" } },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSave("ruleForm")
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new_sidebar" }, [
        _c(
          "div",
          { staticClass: "tree" },
          [
            _c("div", { staticClass: "new_sidebar_head" }, [
              _vm._v("\n        目录\n        "),
              _c(
                "span",
                {
                  staticClass: "tagbar_icon",
                  on: {
                    click: function($event) {
                      return _vm.addTreeItem(0)
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              )
            ]),
            _vm._v(" "),
            _c("el-tree", {
              ref: "tree",
              style: { height: _vm.height },
              attrs: {
                data: _vm.treeData,
                "node-key": "id",
                props: _vm.defaultProps,
                "highlight-current": true,
                "default-expanded-keys": [_vm.defaultExpansion],
                draggable: _vm.openDraggable
              },
              on: { "node-click": _vm.handleNodeClick },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var node = ref.node
                    var data = ref.data
                    return _c(
                      "div",
                      {
                        staticClass: "custom-tree-node",
                        on: {
                          "&mouseleave": function($event) {
                            return _vm.treemouseLeave()
                          },
                          dblclick: function($event) {
                            return _vm.edit(data)
                          },
                          "&mouseover": function($event) {
                            return _vm.treeMouseOver($event, data)
                          }
                        }
                      },
                      [
                        data.id && data.status != 1
                          ? _c(
                              "span",
                              {
                                staticClass: "custom-tree-node-label",
                                attrs: { title: data.catalogName }
                              },
                              [_vm._v(_vm._s(data.catalogName))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        data.status == 1
                          ? _c("el-input", {
                              ref: "edit" + data.id,
                              staticClass: "nodeInput",
                              staticStyle: {
                                width: "90%",
                                "margin-right": "20px"
                              },
                              attrs: {
                                size: "small",
                                placeholder: "添加目录",
                                maxlength: "100"
                              },
                              on: {
                                blur: function($event) {
                                  return _vm.blurEdit(data)
                                }
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.enterBlur($event, data)
                                }
                              },
                              model: {
                                value: data.catalogName,
                                callback: function($$v) {
                                  _vm.$set(data, "catalogName", $$v)
                                },
                                expression: "data.catalogName"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.iconIsShow == data.id
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      "popper-class": "zl_sidebar_popper1",
                                      placement: "bottom",
                                      width: "118",
                                      trigger: "click"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "zl_sidebar_popper_btn",
                                        staticStyle: { "user-select": "none" }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "popper_p",
                                            on: {
                                              click: function($event) {
                                                return _vm.addTreeItem(1, data)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("子目录")])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "popper_p",
                                            on: {
                                              click: function($event) {
                                                return _vm.edit(data)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("编辑")])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "popper_p",
                                            on: {
                                              click: function($event) {
                                                return _vm.remove(node, data)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("删除")])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    data.id
                                      ? _c("span", {
                                          staticClass:
                                            "el-icon-more catalogedtordel",
                                          class: {
                                            "tree-node-block":
                                              _vm.iconIsShow == data.id &&
                                              data.status != 1
                                          },
                                          attrs: { slot: "reference" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openSelectType.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  margin: "10px"
                }
              },
              [
                _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
                  _vm._v("云资料引入")
                ]),
                _vm._v(" "),
                _c("el-drawer", {
                  attrs: {
                    visible: _vm.isAddMaterial,
                    direction: "rtl",
                    size: "80%",
                    "destroy-on-close": "",
                    "with-header": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.isAddMaterial = $event
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "16px" },
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.uploadMaterialDrawer }
                  },
                  [_vm._v("\n          本地资料上传\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-drawer",
                  {
                    attrs: {
                      visible: _vm.isUploadMaterial,
                      direction: "rtl",
                      size: "80%",
                      "destroy-on-close0": "",
                      "with-header": false
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.isUploadMaterial = $event
                      }
                    }
                  },
                  [
                    _c("uploadMaterial", {
                      ref: "uploadMaterial",
                      attrs: {
                        uploadUrl: _vm.uploadUrl,
                        categoryId: _vm.categoryId,
                        projectId: _vm.projectId,
                        subjectId: _vm.subjectId,
                        isUploadMaterial: _vm.isUploadMaterial
                      },
                      on: {
                        uploadMaterial: _vm.uploadMaterial,
                        uploadMaterialClick: _vm.uploadMaterialClick
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.documentObj }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.$index) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "resourceName", label: "资料名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "date", label: "上传时间" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.deleteRow(
                                    scope.$index,
                                    _vm.documentObj
                                  )
                                }
                              }
                            },
                            [_vm._v("\n              移除\n            ")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-169c570a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169c570a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auditNewRealTask/components/marketingProjectContent.vue
// module id = null
// module chunks = 